import { createContext, useContext } from "react";
import { type NodeKey } from "lexical";

export type AnnotationKind = "footnote" | "tooltip";

export type AnnotationController = {
  openInsert: (kind: AnnotationKind) => void;
  openEdit: (kind: AnnotationKind, nodeKey: NodeKey, content: string) => void;
};

export const AnnotationContext = createContext<AnnotationController | null>(
  null,
);

export const useAnnotationContext = () => useContext(AnnotationContext);
